'use strict';

import React,{ Component} from 'react';

class miniTriple extends Component{
    render() {
        //console.log("[DEBUG], Render Class Minichart", this.props.value);
        var val1 = this.props.value1;
        if (val1 != null) {
            val1 = val1.toFixed(0);
        }

        var val2 = this.props.value2;
        if (val2 != null) {

            val2 = val2.toFixed(0);
        }

        var val3 = this.props.value3;
        if (val3 != null) {
            val3 = val3.toFixed(0);
        }

        return (
            <div 
                id="pie-charts"  
                className="dash-widget-item card-dashboard" 
                onClick={this.props.ClickOnMenu} 
                style={{cursor: "pointer"}} 
            >
                <div className={this.props.color}>
                    <div className="dash-widget-header">
                        <div className="dash-widget-title">{this.props.graphName}</div>
                    </div>

                    <div className="clearfix"></div>

                    <div className="text-center p-20 m-t-25">
                        <div className="easy-pie main-pie" data-percent="75">
                            <div className={this.props.percent}>{val1}</div>
                            <div className="pie-title">{this.props.name1}</div>
                            <canvas height="148" width="148"></canvas>
                        </div>
                    </div>
                </div>

                <div className="p-t-20 p-b-20 text-center">
                    <div className="easy-pie sub-pie-1" data-percent="56">
                        <div className={this.props.percent}>{val2}</div>
                        <div className="pie-title">{this.props.name2}</div>
                        <canvas height="95" width="95"></canvas>
                    </div>
                    <div className="easy-pie sub-pie-2" data-percent="84">
                        <div className={this.props.percent}>{val3}</div>
                        <div className="pie-title">{this.props.name3}</div>
                        <canvas height="95" width="95"></canvas>
                    </div>
                </div>

            </div>
        )
    }
};
export default miniTriple